module.exports = __webpack_public_path__ + "cuttingline2.png?20a743d7ee20fac1f617ef7f32fa5144";